import { useState } from 'react';

const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    text: '',
    type: 'alert',
    onConfirm: null
  });

  const openModal = (text, config = {}) => {
    setModalConfig({
      text,
      type: config.type || 'alert',
      onConfirm: config.onConfirm || null
    });
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const showAlert = (text) => {
    openModal(text, { type: 'alert' });
  };

  const showConfirm = (text, onConfirm) => {
    openModal(text, { type: 'confirm', onConfirm });
  };

  return {
    isOpen,
    modalConfig,
    openModal,
    closeModal,
    showAlert,
    showConfirm
  };
};

export default useModal;